import { render, staticRenderFns } from "./myProcessDesign.vue?vue&type=template&id=9322852e&scoped=true"
import script from "./myProcessDesign.vue?vue&type=script&lang=js"
export * from "./myProcessDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9322852e",
  null
  
)

export default component.exports